module.exports = __webpack_public_path__ + "img/logoempresa - copia.2daa649d.png";